import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useParams } from "react-router-dom";

import {
  Campaign,
} from "@dndModels";

import API from "@utilities/smart_api";

import CampaignParent from '@dndComponents/campaign/CampaignParent';
import LoadingBox from '@components/input/LoadingBox';

const api = API.getInstance();

export default function CampaignDetails() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [obj, setObj] = useState<Campaign | null>(null);
  // Forces a re-render when auth changes, since api.user isn't React state
  const [, setPing] = useState(false);
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const load = useCallback(async () => {
    if (!api.user) {
      return;
    }
    if (!id || id === "") {
      // /campaign/create
      setObj(new Campaign());
      return;
    }
    setLoading(true);
    const campaign = await api.getCampaign({ campaign_id: id, include: ["players", "characters"] });
    if (mounted.current) {
      setObj(campaign ? campaign : null);
      setLoading(false);
    }
  }, [id]);

  // On a page refresh the router renders before login finishes, so api.user
  // may still be null here. Wait for the Authenticated event rather than redirecting.
  const authChanged = useCallback(() => {
    setPing(p => !p);
    load();
  }, [load]);

  useEffect(() => {
    api.subscription_holder.subscribe("Authenticated", mounted, authChanged);
    api.subscription_holder.subscribe("Logout", mounted, () => {
      setObj(null);
      setPing(p => !p);
    });
    // In case login completed before this subscription was registered
    load();
  }, [authChanged, load]);

  const height = window.innerHeight - 64;
  if (!api.online) {
    return (
      <>Campaign Editing only works while online.  Try reconnecting.</>
    );
  } else if (loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else if (!api.user || !obj || obj._id !== (id ?? "")) {
    return (
      <span>This page is only visible to users who are in this campaign. If the browser is authenticating it should let you in in a moment if you are in the campaign.</span>
    );
  } else {
    return (
      <CampaignParent campaign={obj} />
    );
  }
}
